
// src/app/custom-icons.init.ts
import { provideAppInitializer } from '@angular/core';
import { addIcons, setAssetPath } from 'ionicons';

const myCustomLogo = `
  data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 32L20 464h472L256 32z" class="ionicon"/></svg>
`;

export function provideCustomIcons() {
	return provideAppInitializer(() => {
		setAssetPath(document.baseURI || '/');
		addIcons({
			'my-custom-logo': myCustomLogo,
		});
	});
}